import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { guardArray } from "@msuite/utils/array";
import { moment } from "@msuite/utils/date";
import { useProtocolEmails } from "@/hooks/use-protocol-emails";
import type { ProtocolPanelBaseProps } from "../shared";

export function ProtocolEmails({ protocolId }: ProtocolPanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { protocolEmails } = useProtocolEmails(protocolId);

	/** Computed */
	const sentEmails = guardArray(protocolEmails);

	/** Render */
	return (
		<ContentCard
			icon={icon("Send")}
			title={t("protocols.sent_emails")}
			defaultIsOpen={sentEmails.length > 0}
		>
			{!sentEmails.length ? (
				<p>{t("protocols.no_sent_emails")}</p>
			) : (
				<div className="v-stack gap-2">
					{sentEmails.map((sentEmail) => (
						<div
							className="justify-between items-center h-stack"
							key={sentEmail.id}
						>
							<p>{sentEmail.email}</p>
							<p className="label tabular-nums">{moment(sentEmail.createdAt).longFormat()}</p>
						</div>
					))}
				</div>
			)}
		</ContentCard>
	);
}
